import {HTMLAttributes} from "react";

const FlexGrid = (props: HTMLAttributes<HTMLDivElement>) => {
    return <div {...props} style={{display: 'flex', flexWrap: 'wrap', columnGap: 12, rowGap: 6, ...props.style}}>
        {props.children}
    </div>
}

export default FlexGrid;

export const FlexGridItem = (props: HTMLAttributes<HTMLDivElement>) => {
    return <div {...props} style={{position: 'relative', width: 200, minWidth: '45%', height: 28, flexGrow: 1, ...props.style}}>
        {props.children}
    </div>
}

export const Columns = (props: HTMLAttributes<HTMLDivElement>) => {
    return <div {...props} style={{display: 'flex', flexDirection: 'column', columnGap: 12, ...props.style}}>
        {props.children}
    </div>
}

export const Column = (props: HTMLAttributes<HTMLDivElement>) => {
    return <div {...props} style={{position: 'relative', display: 'flex', flexDirection: 'row', width: "100%", rowGap: 6, ...props.style}}>
        {props.children}
    </div>
}

export const Row = (props: HTMLAttributes<HTMLDivElement>) => {
    return <div {...props} style={{position: 'relative', width: "100%", ...props.style}}>
        {props.children}
    </div>
}